import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_WIDTH } from 'Styles/variables/sizes';

export const Hamburger = styled.div`
  display: none;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  position: relative;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  z-index: 1;
  flex-direction: column;
  justify-content: space-around;
  div {
    transform-origin: 1px center;
    height: 2px;
    width: 100%;
    background: ${({ theme: { colors } }) => colors.blue_1};
    transition: 0.25s ease-in-out;
  }
  div:first-child {
    transform: rotate(0);
  }
  div:nth-child(2) {
    opacity: 1;
  }
  div:nth-child(3) {
    transform: rotate(0);
  }
  &.is-open {
    div:first-child {
      transform: rotate(45deg);
    }
    div:nth-child(2) {
      opacity: 0;
    }
    div:nth-child(3) {
      transform: rotate(-45deg);
    }
  }
  @media (max-width: ${DESKTOP_WIDTH}) {
    display: flex;
  }
`;
